var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10139IconServiceInstancePools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fab23b23-e919-4dd4-b247-de15da1c5ef9",
    "data-name": "azure-fluent-icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a30745b0-ad63-49cb-b0a6-bfff2ae873e7",
    x1: 5.41,
    y1: 17.33,
    x2: 5.41,
    y2: 4.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a9d4c02a-89a8-4dd3-9cb4-7cc2e8933fb4",
    x1: 10.04,
    y1: -1347.39,
    x2: 10.04,
    y2: -1336.82,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -1330)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1380da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3c91e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#559cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ea0ef"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-databases-138") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.32,12.76a.59.59,0,0,1-.57.57H5.07a.57.57,0,0,1-.57-.57V1.18A.55.55,0,0,1,5.05.61h8.7a.57.57,0,0,1,.57.57Z",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.32,14.76a.59.59,0,0,1-.57.57H3.07a.57.57,0,0,1-.57-.57V3.18a.55.55,0,0,1,.55-.57h8.7a.57.57,0,0,1,.57.57Z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.32,16.76a.59.59,0,0,1-.57.57H1.07a.58.58,0,0,1-.57-.57V5.18a.55.55,0,0,1,.55-.57h8.7a.57.57,0,0,1,.57.57Z",
    fill: "url(#a30745b0-ad63-49cb-b0a6-bfff2ae873e7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94,7.31A1.06,1.06,0,0,1,3,6.24H7.9a1.07,1.07,0,0,1,1.1,1v0H9A1.08,1.08,0,0,1,7.92,8.37H3A1.08,1.08,0,0,1,1.94,7.31Z",
    fill: "#003067"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.06,
    cy: 7.31,
    r: 0.72,
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,14.08a3.35,3.35,0,0,0-2.91-3.22,4.21,4.21,0,0,0-4.35-4A4.31,4.31,0,0,0,6.1,9.64a4,4,0,0,0-3.52,3.85,4.06,4.06,0,0,0,4.2,3.9h7.39A3.38,3.38,0,0,0,17.5,14.08Z",
    fill: "url(#a9d4c02a-89a8-4dd3-9cb4-7cc2e8933fb4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.61,14.45V11.09h-.93v4.12h2.45v-.76ZM6.51,12.8A2.67,2.67,0,0,1,6,12.49a.47.47,0,0,1-.12-.32.32.32,0,0,1,.15-.3.63.63,0,0,1,.42-.12,1.68,1.68,0,0,1,1,.29v-.86a2.82,2.82,0,0,0-1-.15,1.7,1.7,0,0,0-1.09.33,1.08,1.08,0,0,0-.41.89,1.35,1.35,0,0,0,.94,1.2,2.51,2.51,0,0,1,.61.36.42.42,0,0,1,.15.32.33.33,0,0,1-.15.3.78.78,0,0,1-.45.12A1.61,1.61,0,0,1,5,14.13v.92a2.28,2.28,0,0,0,1,.23A1.93,1.93,0,0,0,7.15,15a1.06,1.06,0,0,0,.43-.91,1,1,0,0,0-.25-.7A2.26,2.26,0,0,0,6.51,12.8Zm5.16,1.58A2.33,2.33,0,0,0,12,13.12,2.27,2.27,0,0,0,11.75,12a1.7,1.7,0,0,0-.69-.74A1.88,1.88,0,0,0,10,11a2.1,2.1,0,0,0-1,.29,1.87,1.87,0,0,0-.73.77A2.49,2.49,0,0,0,8,13.2a2.28,2.28,0,0,0,.24,1.05,1.86,1.86,0,0,0,.68.74,2.07,2.07,0,0,0,1,.29l.85,1H12l-1.19-1.1A1.82,1.82,0,0,0,11.67,14.38Zm-.93-.25a.93.93,0,0,1-.76.35.92.92,0,0,1-.75-.36,1.5,1.5,0,0,1-.28-1,1.43,1.43,0,0,1,.29-1,.93.93,0,0,1,.77-.37.87.87,0,0,1,.74.37,1.48,1.48,0,0,1,.28,1A1.47,1.47,0,0,1,10.74,14.13Z",
    fill: "#f2f2f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10139IconServiceInstancePools);
export default __webpack_public_path__ + "static/media/10139-icon-service-Instance-Pools.2b2ff81eb5eb5bc99305f6d9bcac08ae.svg";
export { ForwardRef as ReactComponent };